import { GroupStep, isPassed } from "app/lib/pipeline";
import { twMerge } from "tailwind-merge";
import { bgColorForStep } from "app/components/Playground/Node/colors";
import { useBuild, findChildStepsForGroup } from "app/components/build/Show/lib/BuildContext";

// Given group of steps, display a count of the number of passed steps in that group.
export const GroupStepCount = ({ step }: { step: GroupStep }) => {
  const { build } = useBuild({ strict: false });

  if (!build) {
    return null;
  }

  const childSteps = findChildStepsForGroup(build, step.uuid);

  const passedCount = childSteps.filter((step) => isPassed(step)).length;

  return (
    <span
      className={twMerge(
        "rounded-[4px] border border-current px-1 text-charcoal-700",
        bgColorForStep(step),
        "bg-white",
      )}
    >
      {passedCount}/{childSteps.length}
    </span>
  );
};
